import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Query } from 'react-apollo';
import { LOOKUP } from '../queries';
import { logAmplitudeEvent } from '../utilities';

const SpecialtySelect = ({ value, onChange, ...props }) => {
  return (
    <Query query={LOOKUP} variables={{ type: 'spl' }}>
      {({ loading, data: { lookups = [] } = {} }) => {
        const specialtyOptions = lookups.map(({ label, value }) => ({
          label,
          value
        }));

        const selected =
          value && specialtyOptions.find(opt => opt.value === value);

        return (
          <Select
            {...props}
            isMulti={false}
            isLoading={loading}
            options={specialtyOptions}
            value={selected}
            onChange={v => {
              onChange(v && v.value ? v.value : null);
              logAmplitudeEvent('Quick_Book_Specialty_Select', v, true);
            }}
            isClearable
            placeholder="Specialty"
          />
        );
      }}
    </Query>
  );
};

SpecialtySelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func
};

export default SpecialtySelect;
